import { useCharFit } from "hooks/useCharFit";
import { useStyles } from "./RCALibraryDescriptionExpandedCell.styles";
import { IRCALibraryDescriptionExpandedCell } from "./RCALibraryDescriptionExpandedCellInterfaces";
import { truncateLongText } from "utilities/utilities";

const RCALibraryDescriptionExpandedCell = ({ actionPlan }: IRCALibraryDescriptionExpandedCell) => {
    const classes = useStyles();
    const { cellRef, charsThatCanFit } = useCharFit();

    return (
        <div ref={cellRef} className={classes.descriptionWrapper}>
            <span className={classes.text}>{truncateLongText(actionPlan.description, charsThatCanFit)}</span>
        </div>
    );
};

export default RCALibraryDescriptionExpandedCell;
